module.exports = __webpack_public_path__ + "img/events-selected.5655c62d.svg";